module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.notificationList), function(notification) {
    return _c('router-link', {
      key: notification.id,
      staticClass: "item",
      attrs: {
        "to": ("/timeline/" + (notification.activity.id))
      }
    }, [(notification.senders.length == 1) ? _c('dp', {
      attrs: {
        "who": notification.senders[0]
      }
    }) : _vm._e(), _vm._v(" "), (notification.senders.length > 1) ? _c('div', {
      staticClass: "double-dp"
    }, [_c('dp', {
      attrs: {
        "who": notification.senders[0]
      }
    }), _vm._v(" "), _c('dp', {
      attrs: {
        "who": notification.senders[1]
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.notificationText(notification)) + "\n        ")]), _vm._v(" "), _c('small', {
      staticClass: "pale"
    }, [_vm._v("\n            " + _vm._s(_vm._f("time")(notification.updated_at)) + "\n        ")])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c83b017c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications.vue
// module id = 240
// module chunks = 0